<template>
  <v-dialog 
    v-model="dialog" 
    width="600" 
    content-class="peachList"
  >
    <v-card>
      <v-btn icon absolute right top small @click="dialog = false">
        <v-icon small>fa-times</v-icon>
      </v-btn>
      <v-card-title class="justify-center pt-8">
        購買桃子
      </v-card-title>
      <div class="plans">
        <v-btn block tile depressed v-for="item in peachList" @click="buyPeach(item.id)">
          <div class="d-flex align-center">
            <div class="peach mr-2"></div>{{ item.peaches }}
          </div>
          <div>
            <div class="first_discount" v-if="item.first_reverse">首儲優惠</div>
            NT ${{ item.price_twd }}
          </div>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>  
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      dialog: false,
      peachList: []
    }
  },
  created() {
    let self = this
    this.$root.$on('peachList', () => {
      self.dialog = true
    })
    this.getPeachList()
  },
  computed: {
    ...mapGetters('user', ['isLogin']),
  },
  methods: {
    getPeachList() {
      this.axios.get('/peach/list').then(response => {
        this.peachList = response.data.data
      })
    },
    buyPeach(id) {
      if(this.isLogin) {
        this.axios.get(`/buy/peach/${id}`).then(response => {
          document.write(response.data)
        })
      }
      else {
        this.dialog = false
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.peachList {
  @include mobile {
    margin: 0;
  }
  .plans {
    &:after {
      content: "";
      position: absolute;
      z-index: 1;
      bottom: 0;
      left: 0;
      pointer-events: none;
      background-image: linear-gradient(to bottom, rgba(255,255,255, 0), rgba(255,255,255, .8) 100%);
      width: 100%;
      height: 60px;
    }
    min-height: 300px;
    max-height: 400px;
    overflow: auto;
    padding: 14px 32px 35px 32px;
    @include mobile {
      padding: 14px 15px 35px;
    }
    .v-btn {
      height: 40px;
      margin: 10px 0;
      padding: 0 20px;
      div:first-child {
        font-size: 18px;
        color: $main;
      }
      .v-btn__content {
        display: flex;
        justify-content: space-between;
        span {
          color: lightgrey;
        }
      }
    }
    .first_discount {
      display: inline-block;
      padding: 4px;
      margin-right: 8px;
      border-radius: 12px;
      background-color: $main;
      color: white !important;
      font-weight: 400;
      font-size: 13px !important;
    }
  }
}
</style>